/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type subsidy_CreateSubsidyReportRequest = {
    kind: subsidy_CreateSubsidyReportRequest.kind;
    note?: string;
};
export namespace subsidy_CreateSubsidyReportRequest {
    export enum kind {
        ANTRAG = 'antrag',
        MUTATION = 'mutation',
        AUSTRITT = 'austritt',
    }
}

